import { Command, CommandInput } from "@/shadcn/components/ui/command";

import "@/components/SearchContainer/popoverHeight.scss";
import SearchBoxFilterAdvanced from "@/components/SearchContainer/searchBoxFilterAdvanced.component";
import SearchBoxFilterBasic from "@/components/SearchContainer/searchBoxFilterBasic.component";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shadcn/components/ui/popover";
import { ListFilter } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";

const TaskSearchBox: React.FC = () => {
  // Refs
  const popoverRef = useRef<HTMLDivElement>(null);
  const listFilterRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const advFilterRef = useRef<HTMLDivElement>(null);
  const statusRef = useRef<HTMLDivElement>(null);
  const listedTasksRef = useRef<HTMLDivElement>(null);
  const collaboratorRef = useRef<HTMLDivElement>(null);
  const buttonSectionRef = useRef<HTMLDivElement>(null);
  const buttonRecentSearchesSectionRef = useRef<HTMLDivElement>(null);
  const multiAssigneeRef = useRef<HTMLDivElement>(null);
  const dateDropdownRef = useRef<HTMLDivElement>(null);
  const addFilterRef = useRef<HTMLDivElement>(null);

  // Popover Content Ref
  const popOverContentRef = useRef<HTMLDivElement>(null);

  const [open, setOpen] = useState(false);
  const [filtering, setFiltering] = useState(false);

  // Click outside the popover to close
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      //  Clicked outside the popover
      const clickedOutside = !(
        (popoverRef.current &&
          popoverRef.current.contains(event.target as Node)) ||
        (listFilterRef.current &&
          listFilterRef.current.contains(event.target as Node)) ||
        (advFilterRef.current &&
          advFilterRef.current.contains(event.target as Node)) ||
        (statusRef.current &&
          statusRef.current.contains(event.target as Node)) ||
        (listedTasksRef.current &&
          listedTasksRef.current.contains(event.target as Node)) ||
        (collaboratorRef.current &&
          collaboratorRef.current.contains(event.target as Node)) ||
        (buttonSectionRef.current &&
          buttonSectionRef.current.contains(event.target as Node)) ||
        (buttonRecentSearchesSectionRef.current &&
          buttonRecentSearchesSectionRef.current.contains(
            event.target as Node
          )) ||
        (dateDropdownRef.current &&
          dateDropdownRef.current.contains(event.target as Node)) ||
        (addFilterRef.current &&
          addFilterRef.current.contains(event.target as Node))
      );

      if (clickedOutside) {
        // console.log("clicked outside");
        setOpen(false);

        setTimeout(() => {
          setFiltering(false);
        }, 100);
      } else {
        console.log("clicked inside");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    popoverRef,
    listFilterRef,
    advFilterRef,
    statusRef,
    collaboratorRef,
    listedTasksRef,
    buttonSectionRef,
    buttonRecentSearchesSectionRef,
    addFilterRef,
  ]);

  // Search Input States
  const [inputValue, setInputValue] = useState("");

  return (
    <div
      ref={popoverRef}
      className="relative w-full sm:w-[200px] md:w-[300px] lg:w-[500px]"
    >
      <Command shouldFilter={!filtering} className="h-full">
        <Popover
          open={open}
          onOpenChange={(isOpen) => {
            console.log("Popover open state:", isOpen);

            if (!open && isOpen) {
              // Only allow opening, prevent closing on re-clicking the input
              setOpen(true);
            } else {
              console.log(
                "Popover remains open, prevent it from closing on input click"
              );
            }
          }}
        >
          <PopoverTrigger className="dark:bg-background">
            <div className="bg-background h-9 cursor-text justify-between flex items-center w-full">
              <div
                className="flex-grow"
                onClick={() => {
                  inputRef.current?.focus();
                }}
              >
                <CommandInput
                  ref={inputRef}
                  placeholder="Search"
                  className="h-9 bg-background "
                  value={inputValue}
                  onValueChange={(value) => setInputValue(value)}
                  disabled={filtering}
                />
              </div>
              <div
                ref={listFilterRef}
                className="flex-shrink-0"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <ListFilter
                  className="w-4 h-4 mr-3 cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpen(true);
                    setFiltering(!filtering);
                  }}
                />
              </div>
            </div>
          </PopoverTrigger>
          <PopoverContent
            onOpenAutoFocus={(e) => e.preventDefault()}
            className="w-[100vw] sm:w-full md:w-[300px] lg:w-[500px] p-0 !max-h-full h-full"
            ref={popOverContentRef}
          >
            <div className="h-full">
              {filtering ? (
                <SearchBoxFilterAdvanced
                  advFilterRef={advFilterRef}
                  statusRef={statusRef}
                  multiAssigneeRef={multiAssigneeRef}
                  dateDropdownRef={dateDropdownRef}
                  collaboratorRef={collaboratorRef}
                  buttonSectionRef={buttonSectionRef}
                  addFilterRef={addFilterRef}
                  popOverContentRef={popOverContentRef}
                  filtering={filtering}
                  inputValue={inputValue}
                />
              ) : (
                <SearchBoxFilterBasic
                  inputRef={inputRef}
                  buttonRecentSearchesSectionRef={buttonSectionRef}
                  listedTasksRef={listedTasksRef}
                />
              )}
            </div>
          </PopoverContent>
        </Popover>
      </Command>
    </div>
  );
};

export default TaskSearchBox;
